(ns ncr.widgets.domain
  (:require
   [clojure.string :as str]
   [clojure.core.match :refer [match]]
   [uix.core.alpha :as uix]
   [ncr.me :as me]
   [ncr.etc.util :as u]
   [ncr.widgets.pf :as wpf]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.pf :as pf]
   [goog.object :as gob]))

(def spec-everyone
  {:name "All Users" :label-fn :name :id "$everyone"})

(def ^:private recent-users-count 3)
(defn- recent-users-pref-key [write?]
  (str "neckar.permissions.recent-users." (if write? "write" "read")))

(defn- read-recent-users-pref [write?]
  (filter seq
    (-> (recent-users-pref-key write?)
      js/localStorage.getItem
      (or "")
      (str/split #","))))

(defn- write-recent-users-pref [write? recent-users]
  (->> recent-users
    (filter seq)
    (str/join ",")
    (js/localStorage.setItem (recent-users-pref-key write?))))

(defn c-users-selector [{:keys [form id] :as props}]
  (let
    [me (uix/context me/*context*)

     users
     (->> (get-in me [:cluster :users])
       (filter :active))

     write? (= :write-acl (:name props))

     specials (get props :specials)

     recent-user-by-id
     (fn [id]
       (select-keys
         (or
           (some #(when (= id (:id %)) %) specials)
           (me/user-by-id me id))
         [:id :name]))

     recent-users
     (uix/state
       (->> (read-recent-users-pref write?)
         (map recent-user-by-id)
         (filter #(seq (:name %)))))

     by-id (u/index-by :id (concat users specials))

     is-disabled (get props :is-disabled)

     on-empty-enter (get props :on-empty-enter)

     field-name (:name props)]

    [rhf/c-controller
     {:name field-name
      :control (:control form)
      :render
      (fn [props]
        (let
          [selections (into #{} (get-in props [:field :value]))
           {:keys [get-values set-value]} form]
          [:<>
           [wpf/c-pf-select
            {:toggle-id id
             :class :ncr-permissions-select
             :variant :typeaheadmulti
             :is-grouped true
             :is-disabled is-disabled
             :label-fn :name
             :selections
             (->> selections
               (select-keys by-id)
               (vals))
             :max-height "200px"
             :on-empty-enter on-empty-enter

             :on-select
             (fn [_ {:keys [id]} _]
               (let
                 [update (-> props :field :on-change)
                  removed? (contains? selections id)]
                 (update
                   (clj->js
                     (if removed?
                       (disj selections id)
                       (conj selections id))))
                 (when-not removed?
                   (let
                     [cur-recent-users @recent-users
                      new-recent-users
                      (->> cur-recent-users
                        (filter #(not= id (:id %)))
                        (cons (recent-user-by-id id))
                        (take recent-users-count))]
                     (reset! recent-users new-recent-users)
                     (write-recent-users-pref write? (map :id new-recent-users))))))}

            [{:label "Users" :key "users" :options (sort-by :name users)}
             (when (seq specials)
               {:label "Special" :key "special" :options specials})]]
           [pf/c-chip-group {:class :ncr-recent}
            (for [{:keys [id] :as ru} @recent-users]
              ^{:key id}
              [pf/c-chip
               {:is-overflow-chip true
                :component "button"
                :on-click
                (fn [_]
                  (let
                    [recent-user-ids
                     (set
                       (or
                         (gob/get (get-values) (name field-name))
                         (array)))]
                    (set-value field-name
                      (clj->js
                        (if (contains? recent-user-ids id)
                          (disj recent-user-ids id)
                          (conj recent-user-ids id)))
                      {:shouldDirty true :shouldTouch true})))}
               (:name ru)])]]))}]))

(defn c-user-selector [{:keys [id] :as props}]
  (let
    [filter-fn
     (get props :filter-fn (constantly true))

     users
     (->> (get-in (uix/context me/*context*) [:cluster :users])
       (filter :active)
       (filter filter-fn))
     by-id (u/index-by :id users)
     is-disabled (get props :is-disabled)]

    [rhf/c-controller
     (merge
       (select-keys props [:name :rules])
       {:control (get-in props [:form :control])
        :render
        (fn [props]
          (let
            [selection (get-in props [:field :value])]
            [wpf/c-pf-select
             {:variant :typeahead
              :toggle-id id
              :is-disabled is-disabled
              :label-fn :name
              :selections
              (get by-id selection)
              :max-height "200px"

              :on-select
              (fn [_ {:keys [id]} _]
                ((-> props :field :on-change) id))}
             (sort-by :name users)]))})]))
